import React from 'react';
import AbstractComponent from '../AbstractComponent';
import Button from '../layout/button/Button';
import ActionButton from '../layout/button/ActionButton';

import NotificacaoService from '../../service/NotificacaoService';

class NotificacaoActionButton extends AbstractComponent {   
    constructor(props) {
        super(props);

        this.state = {
            preload: false,

            erro: {
                message: '',
                code: 0
            },

            textoSucesso: ''
        }
    }  

    onClick() {
        this.setState({
            erro: {
                message: '',
                code: 0
            },
            preload: true
        })

        NotificacaoService.changeStatus(
            this.props.uuid_notificacao,
            'Aguardando Envio'
        ).then(() => {      
            this.props.onReadOnly()

            this.setState({ 
                preload: false,
                textoSucesso: 'Notificações liberadas para envio com sucesso'
            });            
        }).catch(erro => {                        
            this.setState({
                erro: this.trataErro(erro),
                preload: false
            })
        });
    }    

    render() {
        return (  
            <ActionButton                    
                visible={this.props.visible} 
                preload={this.state.preload}
                textoSucesso={this.state.textoSucesso}                               
                erro={this.state.erro}         

                onTimeOut={() => this.setState({textoSucesso: ''})}
                onClose={() => this.setState({erro: this.finalizaErro(this.state.erro)})}
            >
                <Button 
                    className="btn btn-success"
                    type="button"
                    background={3}
                    style={{width: '100%'}}
                    onClick={() => this.onClick()}                    
                >
                    Liberar
                </Button>                   
            </ActionButton>         
        )
    }
}

export default NotificacaoActionButton;